export var SettingsTypes;
(function (SettingsTypes) {
    SettingsTypes["quality"] = "quality";
    SettingsTypes["qualityAuto"] = "qualityAuto";
    SettingsTypes["sounds"] = "sounds";
    SettingsTypes["isLeft"] = "isLeft";
    SettingsTypes["controlsType"] = "controlsType";
    SettingsTypes["aimSensitivity"] = "aimSensitivity";
    SettingsTypes["vibrations"] = "vibrations";
    SettingsTypes["oneFinger"] = "oneFinger";
})(SettingsTypes || (SettingsTypes = {}));
export var ControlsTypes;
(function (ControlsTypes) {
    ControlsTypes[ControlsTypes["joystick"] = 0] = "joystick";
    ControlsTypes[ControlsTypes["doubleButton"] = 1] = "doubleButton";
    ControlsTypes[ControlsTypes["autoTuck"] = 2] = "autoTuck";
})(ControlsTypes || (ControlsTypes = {}));
//# sourceMappingURL=index.js.map